import { axios } from '$app-web/api/axios';
import { Session } from '$app-web/types';

import { Endpoints } from '../constant';

interface IResponse {
    registrations: Array<{
        study: {
            activities: Array<{
                sessions?: Array<Session>;
            }>;
        };
    }>;
}

export async function fetchInProgressSessions(studyId: number) {
    const params = { study_ids: studyId.toString(), sessions_only: true };

    try {
        const { status, data } = await axios.get<IResponse>(`${Endpoints.StudyRegistration.Read}`, { params });

        if (status === 200) {
            const targetActivities = data.registrations[0].study.activities;
            return targetActivities.flatMap((activity) => activity.sessions || []);
        } else {
            return [];
        }
    } catch {
        return [];
    }
}
